import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import VeeValidate, { Validator } from "vee-validate";
import De from "./locale/de";
import VCalendar from "v-calendar";

Vue.config.productionTip = false;

Vue.use(VCalendar);

let appElement = document.getElementById("app");
if (appElement) {
    Vue.use(VeeValidate, { locale: "de", events: "input|blur" });
    Validator.localize("de", De);

    new Vue({
        store,
        router,
        render: (h) => h(App),
    }).$mount("#app");
}
